import AppHeader from '../AppHeader'

export default {
  name: 'master-category-list',
  created () {
    this.getCategory()
  },
  data () {
    return {
      categories: '',
      categoryName: '',
      searchCallbackFlag: true
    }
  },
  computed: {
    loading () {
      return this.$store.getters.apiLoading
    },
    authToken () {
      return window.localStorage.getItem('access_token')
    }
  },
  components: {
    AppHeader
  },
  methods: {
    async getCategory () {
      let data = {}
      let res = await this.$store.dispatch('GET_CATEGORY_LIST', {data: data})
                                  .catch(err => {
                                    console.log(err)
                                    return
                                  })

      this.categories = res.categories
      this.searchCallbackFlag = true
    },
    goCategoryNew () {
      this.$router.push({path: '/master_category/new'})
    },
    goCategoryEdit (categoryId) {
      this.$router.push({path: `/master_category/${categoryId}/edit`})
    },
    async categoryDelete (categoryId) {
      if (!window.confirm('このカテゴリーを削除しますか？')) {
        return
      }

      // 該当カテゴリーの消耗品が登録されているか確認
      let res = await this.$store.dispatch('GET_CATEGORY_PRODUCTS', {id: categoryId, data: {}})
      .catch(err => {
        console.log(err)
        return
      })

      if (res.exist) {
        window.alert('このカテゴリーの消耗品が登録されています。\n該当の消耗品を削除してください。')
      } else {
        await this.$store.dispatch('DELETE_CATEGORY', {id: categoryId, data: {}})
                                  .catch(err => {
                                    console.log(err)
                                    return
                                  })
        this.getCategory()
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/master-category-list.js